import { render, staticRenderFns } from "./ClientProfile.vue?vue&type=template&id=00b921e3&scoped=true&"
import script from "./ClientProfile.vue?vue&type=script&lang=js&"
export * from "./ClientProfile.vue?vue&type=script&lang=js&"
import style0 from "./ClientProfile.vue?vue&type=style&index=0&id=00b921e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b921e3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VContainer,VIcon,VRow,VTextField})
